import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M8.818 8L5 4.11 6.09 3 11 8l-4.91 5L5 11.89 8.818 8z'
      ></path>
    </svg>
  )
}

export default Icon
